/*
  Entry point for FullStack.cash React Bootstrap SPA
*/

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { QueryParamProvider } from 'use-query-params'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <HelmetProvider>
    <QueryParamProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryParamProvider>
  </HelmetProvider>
)
